import type { ReactNode } from "react";
import { Navigate } from "react-router-dom";
import { useAuthStatus } from "@/hooks/useAuth";
import { NoindexSeo } from "@/components/Seo";

/**
 * Garde de route admin : exige un utilisateur connecté, email vérifié ET
 * `is_admin`. Sinon redirige (login si non connecté, dashboard si non admin).
 * Le backend reste la source de vérité (dépendance admin_user) — cette garde
 * n'est qu'un confort UX.
 *
 * noindex : le back-office admin ne doit jamais apparaître en SERP.
 */
export function RequireAdmin({ children }: { children: ReactNode }) {
  const { isAuthenticated, isLoading, user } = useAuthStatus();

  if (isLoading) {
    return (
      <>
        <NoindexSeo />
        <div className="flex min-h-screen items-center justify-center text-gray-500">
          Chargement…
        </div>
      </>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (!user?.is_admin) {
    return <Navigate to="/dashboard" replace />;
  }

  return (
    <>
      <NoindexSeo />
      {children}
    </>
  );
}
